import { render, staticRenderFns } from "./WidgetWallet.vue?vue&type=template&id=fa7bc846&scoped=true"
import script from "./WidgetWallet.vue?vue&type=script&lang=js"
export * from "./WidgetWallet.vue?vue&type=script&lang=js"
import style0 from "./WidgetWallet.vue?vue&type=style&index=0&id=fa7bc846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7bc846",
  null
  
)

export default component.exports